<template>
  <el-dialog
      v-el-drag-dialog
      :title="role.id? '编辑角色' : '新增角色'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      class="role-edit"
      width="1000px"
      top="1vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        :rules="ruleValidate"
        :model="role"
        class="form"
        label-width="80px">
      <el-form-item label="角色名称" prop="roleName">
        <el-input v-model="role.roleName" placeholder="请输入"/>
      </el-form-item>
      <el-form-item label="备注" prop="note">
        <el-input v-model="role.note" placeholder="请输入" type="textarea"/>
      </el-form-item>
      <el-form-item label="功能权限">
        <el-table
            :data="functions"
            border
            height="55vh"
            style="width: 100%; margin-top: 10px;"
            :show-header="true">
          <el-table-column prop="label" label="组" width="220">
            <template slot-scope="scope">
              <el-checkbox
                  :value="role.fauthorization[scope.row.other] == 1"
                  :label="scope.row.label"
                  @change="checkRowChange(scope.row)">
                {{scope.row.label}}
              </el-checkbox>
            </template>
          </el-table-column>
          <el-table-column prop="children" label="功能">
            <template slot-scope="scope">
              <el-checkbox
                  v-for="(item,index) in scope.row.children"
                  :key="index"
                  :value="role.fauthorization[item.other] == 1"
                  :label="item.label"
                  @change="checkChange(item)">
                {{item.label}}
              </el-checkbox>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name:"RoleEdit",
    data() {
      return {
        dialogVisible: false,
        contentLoading: true,
        submitLoading: false,
        role: {
          id: 0,
          roleName: "",
          note: "",
          fauthorization: "0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000",
        },
        functions: [],
        ruleValidate: {
          roleName: [
            {
              required: true,
              trigger: "blur",
              message: "名称不能为空",
            },
          ],
        },
      };
    },
    methods: {
      open(id) {
        this.dialogVisible = true;
        this.role.id = id;
        if(id>0) {
          this.getData();
        }
        this.getFunctionData();
      },
      getData() {
        this.$http
          .get("basic", `roles/${this.role.id}`)
          .then(resp => {
            this.role = resp;
          });
      },
      getFunctionData() {
        this.$http
          .get("basic", "functions/tree")
          .then(resp => {
            this.functions = resp;
          });
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "roles", this.role)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      checkRowChange(obj) {
        let val = this.change(obj.other);
        let parentId = obj.id;
        for(let item of this.functions) {
          if(item.id == parentId) {
            for(let child of item.children) {
              this.change(child.other, val);
            }
          }
        }
      },
      checkChange(obj) {
        let val = this.change(obj.other);
        let parentId = obj.parentId;
        for(let item of this.functions) {
          if(item.id == parentId) {
            for(let child of item.children) {
              if(this.role.fauthorization[child.other] != val) {
                if(val == "0") {
                  this.change(item.other, val);
                }
                return;
              }
            }
            this.change(item.other, val);
          }
        }
      },
      change(index, val) {
        if(val) {
          this.role.fauthorization = this.role.fauthorization.substring(0,index) + val + this.role.fauthorization.substring(index+1,this.role.fauthorization.length);
          return "";
        }
        if(this.role.fauthorization[index] == 0) {
          this.role.fauthorization = this.role.fauthorization.substring(0,index) + "1" + this.role.fauthorization.substring(index+1,this.role.fauthorization.length);
          return "1";
        } else {
          this.role.fauthorization = this.role.fauthorization.substring(0,index) + "0" + this.role.fauthorization.substring(index+1,this.role.fauthorization.length);
          return "0";
        }
      },
    },
  };
</script>

<style lang="scss">
</style>
